var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 21.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#ebf6fb;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.12,0H1.88c-.5,0-.97,.2-1.33,.57-.35,.36-.55,.86-.55,1.37V20.02c0,.51,.2,1.01,.55,1.37,.35,.36,.83,.57,1.33,.57H28.12c.5,0,.97-.2,1.33-.57,.35-.36,.55-.86,.55-1.37V1.94c0-.51-.2-1.01-.55-1.37-.35-.36-.83-.57-1.33-.57Zm-.4,1.29L15,11.46,2.28,1.29H27.73ZM1.25,19.76V2.11l9.63,7.69L1.25,19.76Zm.88,.91L11.88,10.6l2.74,2.19c.11,.09,.24,.13,.38,.13s.27-.05,.38-.13l2.75-2.19,9.74,10.07H2.13Zm26.62-.91l-9.63-9.96L28.75,2.11V19.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailicon);
export default __webpack_public_path__ + "static/media/emailicon.f14ff689fe2d711a6407b279d0437bf6.svg";
export { ForwardRef as ReactComponent };